import { isNil } from 'lodash-es';

import { type Dimension } from './utils/get-dimensions.js';

/**
 * @internal
 */
export function createName(dimensions: Array<Dimension>, valueName: string) {
  const name = [
    ...dimensions
      .map((d) =>
        typeof d.value === 'object'
          ? JSON.stringify(d.value)
          : d.value?.toString(),
      )
      .filter((x): x is string => !isNil(x)),
    valueName,
  ];

  return name;
}
